// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3gAEz","content":"styles_content__22vZ0"};